module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "evaluate"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s((_vm.company && _vm.company._id ? (_vm.evaluate.alias ? _vm.evaluate.alias : _vm.evaluate.name) : _vm.evaluate.name) + (_vm.company && _vm.company._id ? ('-' + _vm.company.name) : '')))]), _vm._v(" "), _c('div', {
    staticClass: "infos"
  }, [_c('span', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.evaluate.evaluate_num) + "人测试过")]), _vm._v(" "), _c('span', {
    staticClass: "item hidden-xs"
  }, [_vm._v(_vm._s(_vm._f("format")(_vm.evaluate.create_at)) + "发布")]), _vm._v(" "), _c('span', {
    staticClass: "item right"
  }, [_vm._v("本次测试共\n                    "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.evaluate.questions_num))]), _vm._v("题")])]), _vm._v(" "), _c('div', {
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.evaluate.desc)
    }
  }), _vm._v(" "), (_vm.evaluate.duration != -1) ? _c('div', {
    staticClass: "timer m-t-b-sm"
  }, [_vm._v("\n                本次测评限时\n                "), _c('span', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.evaluate.duration / 60))]), _vm._v("分钟，超时后将自动结束测评。\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "actions m-t-sm"
  }, [(_vm.is_initialize === -1) ? _c('router-link', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button",
      "to": {
        'name': '/auth/initialize',
        params: {
          code: _vm.code
        },
        query: _vm.user
      },
      "disabled": _vm.is_processing === 1,
      "tag": "button"
    }
  }, [_vm._v("用户初始化")]) : _vm._e(), _vm._v(" "), (_vm.is_login === -1 && _vm.is_initialize !== -1) ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.is_processing === 1
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("用户登录")]) : _vm._e(), _vm._v(" "), (_vm.is_login === 1 && _vm.finish.status > 1) ? _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.is_processing === 1
    },
    on: {
      "click": _vm.report
    }
  }, [_vm._v("查看报告")]) : _vm._e(), _vm._v(" "), (_vm.is_login === 1 && _vm.finish.status === 0) ? _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.is_processing == 1
    },
    on: {
      "click": _vm.startEvaluate
    }
  }, [_vm._v("开始测评")]) : _vm._e(), _vm._v(" "), (_vm.is_login === 1 && _vm.finish.status === 1) ? _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.is_processing == 1
    },
    on: {
      "click": _vm.startEvaluate
    }
  }, [_vm._v("继续测评")]) : _vm._e()], 1), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h5', {
    staticClass: "text-center m-t-b-sm"
  }, [_vm._v("本次测评由\n                    "), _c('a', {
    staticStyle: {
      "color": "#000"
    },
    attrs: {
      "href": "http://www.psych.cas.cn",
      "title": "中国科学院心理研究所",
      "alt": "中国科学院心理研究所"
    }
  }, [_vm._v("中国科学院心理研究所")]), _vm._v(" 提供测评技术支持")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dc72581","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/evaluate/show.vue
// module id = 463
// module chunks = 1